
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StockPropertiesFooterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Stocks_Stock"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"capitalization"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"priceDiff"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StockTopCardFeesFragment"},"directives":[]}]}}],"loc":{"start":0,"end":195}};
    doc.loc.source = {"body":"#import './components/Fees/fragment.gql'\n\nfragment StockPropertiesFooterFragment on Stocks_Stock {\n  id\n  capitalization {\n    value\n    currency\n  }\n  priceDiff \n  ...StockTopCardFeesFragment\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./components/Fees/fragment.gql').definitions));


      module.exports = doc;
    
